// test1796
(1796 && 0);
